import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { openNotification } from "src/components/helpers/notification"
import ax from "src/store/config"

const initialState = {
  PaymentsToCoachesList: null,
  PaymentsToCoachesListLoading: false,
  PacketContentForUser: null,
}

export const PaymentsToCoachesAction = createAsyncThunk(
  "payments/paymentsToCoachesAction",
  async (payload, { dispatch }) => {
    dispatch(setPaymentsToCoachesListLoading(true))
    try {
      const { data } = await ax.get("api/admin/directory/getTrainersPayment", {
        params: payload.value,
      })
      dispatch(setPaymentsToCoachesListLoading(false))
      return data
    } catch (error) {
      dispatch(setPaymentsToCoachesListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${
          error.response?.data?.errorMessages?.[0]?.errorCode || ""
        }. ${
          error.response?.data?.errorMessages?.[0]?.errorMessage ||
          error.message
        }`,
      })
      throw error
    }
  }
)

export const getPacketContentForUser = createAsyncThunk(
  "payments/getPacketContentForUser",
  async (payload) => {
     //console.log("Отправляем запрос при клике на пакет")
    try {
      if (payload.flag === "get") {
        const { data } = await ax.get(
          "/api/admin/directory/personalTrainings",
          {
            params: payload.value,
          }
        )
        return data
      } else if (payload.flag === "delete") {
        const { data } = await ax.delete(
          "/api/admin/directory/personalTrainings",
          {
            params: payload.value,
          }
        )
        openNotification({
          type: "success",
          message: "Тренировка успешно удалена",
        })
        return data
      }
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${
          error.response?.data?.errorMessages?.[0]?.errorCode || ""
        }. ${
          error.response?.data?.errorMessages?.[0]?.errorMessage ||
          error.message
        }`,
      })
      throw error
    }
  }
)

const PaymentsToCoachesSlice = createSlice({
  name: "PaymentsToCoachesTable",
  initialState,
  reducers: {
    setPaymentsToCoachesListLoading: (state, action) => {
      state.PaymentsToCoachesListLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PaymentsToCoachesAction.fulfilled, (state, action) => {
      state.PaymentsToCoachesList = action.payload
    })
    builder.addCase(getPacketContentForUser.fulfilled, (state, action) => {
        state.PacketContentForUser = action.payload;
      })
  },
})

export const { setPaymentsToCoachesListLoading } =
  PaymentsToCoachesSlice.actions
export default PaymentsToCoachesSlice.reducer
